// extracted by mini-css-extract-plugin
export default {"wrapper":"Checkbox_wrapper__5640I","input":"Checkbox_input__8Moe3","required":"Checkbox_required__RnyMA","label":"Checkbox_label__G5uOg"};